export default __webpack_public_path__ + "images/3cdebb29dd1c4584b5743b50af6eda6a-mountain.webp";